export const lowerFirstLetter = ([first, ...rest]: string): string =>
  first ? first.toLowerCase() + rest.join('') : ''
